import React, { useEffect, useLayoutEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingSpinner from "../../../../atoms/loading-spinner";
import ModalManager from "../../../../atoms/modal-manager";
import { IconLink } from "../../../../atoms/links";
// import CONFIG from "../../../../../lib/config";
import LocationDetails from "../../../../../data-containers/location-details";
import Fleets from "../../../../../data-containers/fleets";
import AddHubModal from "../../../../modals/add-hub";
import ErrorWithTooltip from "../../../../atoms/error-with-tooltip";
import DynamicCell from "../../../../atoms/table/dynamic-cell";
// import ImpersonationButton from "./impersonation-button";
import HubConnectivityStatus from "../../../../hub/connectivity-status";
// import HubObject from "../../../../hub/hub-object";

// const EditHubLink = ({ installation, location, user }) => {
//   const { DEMO, DEMO_LOCATION_ID, CONNECT_URL } = CONFIG.values;

//   const impersonationLocationId = DEMO ? DEMO_LOCATION_ID : location.id;

//   const params = {
//     host: CONNECT_URL,
//     queryParams: {
//       entry: `/locations/${impersonationLocationId}/hubs/${installation.hub}`,
//     },
//   };

//   if (!user || !user.user_id) {
//     return null;
//   }

//   return (
//     <ImpersonationButton
//       userId={user.user_id}
//       loadingSpinnerClassName="inline full tiny"
//       params={params}
//     >
//       <span className="linked-icon edit-hub-link">
//         <FontAwesomeIcon icon="pencil-alt" />
//       </span>
//     </ImpersonationButton>
//   );
// };

/* TODO make a separate installation component with its own effect hook to load hub and hubconnectivity */

function InstallationsContent(props) {
  const { getDetail, getImpersonationUser, fetchInstallationsExtended } =
    LocationDetails.useContainer();
  const { fleetPermissions } = Fleets.useContainer();
  const { location_can_edit_hub, location_can_add_hub } = fleetPermissions;
  const { adjustRowHeight, rowData = { get: null }, omitAddToActive } = props;
  const { id, expanded } = rowData;
  const detail = getDetail(id) || {};
  const { installations = [], installationsLoading = true } = detail;

  useEffect(() => {
    if (detail.id && !installations.length) {
      fetchInstallationsExtended(id, { fetchConnectivity: true });
    }
  }, [detail.id]);

  useLayoutEffect(() => {
    adjustRowHeight();
  }, [installations.length, expanded]);

  if (installationsLoading) {
    return <LoadingSpinner className="inline" />;
  }
  if (!installations.length) {
    return null;
  }

  const addHubModalProps = {
    className: "add-hub-modal",
    render: (modalProps) => <AddHubModal {...modalProps} location={rowData} />,
  };

  const impersonationUser = getImpersonationUser(id);

  return (
    <React.Fragment>
      <div className="explorer-list installation-list list">
        {installations.map((inst) => {
          if (
            inst.hubConnectivity &&
            inst.hubConnectivity.error &&
            inst.hubConnectivity.error.status === 403
          ) {
            return null;
          }
          return (
            <div
              className="explorer-item installation-item list-item"
              key={inst.hub}
            >
              <div className="hub-status">
                {/* connectivity */}
                <HubConnectivityStatus id={id} installation={inst} />
              </div>

              {expanded && (
                <React.Fragment>
                  <div className="row-expanded-section light">
                    {inst.loading && <LoadingSpinner className="inline tiny" />}
                    {inst.error && (
                      <ErrorWithTooltip
                        className="installation-error"
                        error={inst.error}
                      />
                    )}
                    {/* <HubObject id={id} installation={inst} /> */}
                  </div>
                  {/* serial */}
                  <div className="serial-number">{inst.hub}</div>
                </React.Fragment>
              )}
              {location_can_add_hub && expanded && (
                <ModalManager
                  modalProps={addHubModalProps}
                  render={() => (
                    <IconLink
                      icon="plus"
                      className="add-user"
                      style={{ padding: ".5rem 0rem" }}
                    >
                      Add Hub
                    </IconLink>
                  )}
                />
              )}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
}

function Wrapper(props) {
  return (
    <div className="location-row-installations">
      <InstallationsContent {...props} />
    </div>
  );
}

export default DynamicCell(Wrapper);
